/* +------------------------------------------------------+
 * |                      pPPa                            |
 * |                    pPPAPPp                           |
 * |                   APP  PPa                           |
 * |                  APA  pPP  PapA  PapA                |
 * |                 PPA   APA pP  P pP  P                |
 * |             APPPPPPPA PPp Ap Ap Ap Ap                |
 * |             apPPA    aPP  P     P                    |
 * |              APA     pPP  p     p                    |
 * |             pPP      PPA                             |
 * |             PPp      PPPp                            |
 * |                                                      |
 * | Created by:    App Software                          |
 * | Email:         info@appsoftware.nl                   |
 * | Web:           http://www.appsoftware.nl/            |
 * |                                                      |
 * +------------------------------------------------------+
 */
'use strict';

/**
 * Generic VUGRON functions
 * */

// eslint-disable-next-line no-redeclare
var VUGRON = VUGRON || {};

VUGRON.Main = function($) {

	let $body = $("body");
	let bootstrap_tpl = $body.hasClass('bootstrap_tpl');

	/* eslint-disable no-useless-escape */
	const constants = {
		pattern_email: "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&''*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?", // custom email address pattern because default HTML5 email pattern accepts email addresses without extension
		pattern_iban: "^[A-Z]{2}\\d{2}[A-Z0-9]{1,30}$", // Algemene IBAN pattern voor alle SEPA landen
		pattern_zip_NL: "[1-9][0-9]{3}\\s?[a-zA-Z]{2}\\s*",
		pattern_zip_BE: "[0-9]{4}\\s*",
		pattern_zip_DE: "[0-9]{5}\\s*",
		zip_message: "Ongeldige postcode",
		zip_message_DE: "Ungültige Postleitzahl"
	};
	/* eslint-enable no-useless-escape */

	function init() {
		jQueryUI_datepicker();
		jQueryUI_slider();
		jQueryUI_autocomplete();
		form_validation();
		autoExecPageLoad();
		toggleRelatedItems();
	}

	// Obtained from Apache Licensed code here:
	// https://stackoverflow.com/questions/990904
	function normalize(str) {
		let diacriticsRemovalMap = [
			{'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
			{'base':'AA','letters':/[\uA732]/g},
			{'base':'AE','letters':/[\u00C6\u01FC\u01E2]/g},
			{'base':'AO','letters':/[\uA734]/g},
			{'base':'AU','letters':/[\uA736]/g},
			{'base':'AV','letters':/[\uA738\uA73A]/g},
			{'base':'AY','letters':/[\uA73C]/g},
			{'base':'B', 'letters':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
			{'base':'C', 'letters':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
			{'base':'D', 'letters':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
			{'base':'DZ','letters':/[\u01F1\u01C4]/g},
			{'base':'Dz','letters':/[\u01F2\u01C5]/g},
			{'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
			{'base':'F', 'letters':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
			{'base':'G', 'letters':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
			{'base':'H', 'letters':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
			{'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
			{'base':'J', 'letters':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
			{'base':'K', 'letters':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
			{'base':'L', 'letters':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
			{'base':'LJ','letters':/[\u01C7]/g},
			{'base':'Lj','letters':/[\u01C8]/g},
			{'base':'M', 'letters':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
			{'base':'N', 'letters':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
			{'base':'NJ','letters':/[\u01CA]/g},
			{'base':'Nj','letters':/[\u01CB]/g},
			{'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
			{'base':'OI','letters':/[\u01A2]/g},
			{'base':'OO','letters':/[\uA74E]/g},
			{'base':'OU','letters':/[\u0222]/g},
			{'base':'P', 'letters':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
			{'base':'Q', 'letters':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
			{'base':'R', 'letters':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
			{'base':'S', 'letters':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
			{'base':'T', 'letters':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
			{'base':'TZ','letters':/[\uA728]/g},
			{'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
			{'base':'V', 'letters':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
			{'base':'VY','letters':/[\uA760]/g},
			{'base':'W', 'letters':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
			{'base':'X', 'letters':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
			{'base':'Y', 'letters':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
			{'base':'Z', 'letters':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
			{'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
			{'base':'aa','letters':/[\uA733]/g},
			{'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
			{'base':'ao','letters':/[\uA735]/g},
			{'base':'au','letters':/[\uA737]/g},
			{'base':'av','letters':/[\uA739\uA73B]/g},
			{'base':'ay','letters':/[\uA73D]/g},
			{'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
			{'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
			{'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
			{'base':'dz','letters':/[\u01F3\u01C6]/g},
			{'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
			{'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
			{'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
			{'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
			{'base':'hv','letters':/[\u0195]/g},
			{'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
			{'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
			{'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
			{'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
			{'base':'lj','letters':/[\u01C9]/g},
			{'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
			{'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
			{'base':'nj','letters':/[\u01CC]/g},
			{'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
			{'base':'oi','letters':/[\u01A3]/g},
			{'base':'ou','letters':/[\u0223]/g},
			{'base':'oo','letters':/[\uA74F]/g},
			{'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
			{'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
			{'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
			{'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
			{'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
			{'base':'tz','letters':/[\uA729]/g},
			{'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
			{'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
			{'base':'vy','letters':/[\uA761]/g},
			{'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
			{'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
			{'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
			{'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
		];
		let result = str.toLowerCase().normalize();
		for (let i=0; i<diacriticsRemovalMap.length; i++) {
			result = result.replace(diacriticsRemovalMap[i].letters, diacriticsRemovalMap[i].base);
		}
		return result;
	}

	function jQueryUI_datepicker() {
		if (typeof $.fn.datepicker === 'function') {
			$.datepicker.setDefaults( $.datepicker.regional[ "nl" ] );

			let uidp = $('.datepicker');
			uidp.each(function() {
				let $me = $(this);
				let minDate;
				let maxDate;
				let defaultDate;
				let disabledDays;
				let closedDays;
				let input;

				if ($me.data('disabled_dates')) {
					disabledDays = $me.data('disabled_dates').split(',');
				}
				if($me.data('closed_dates')) {
					closedDays = $me.data('closed_dates').split(',');
				}
				if($me.data('min')) {
					minDate = $me.data('min');
				}
				if($me.data('max')) {
					minDate = $me.data('max');
				}

				if($me.data('input')) {
					input = $("input[name='" + $(this).data('input') + "']");
					if(input.data('min')) {
						minDate = input.data('min');
					}
					if(input.data('max')) {
						maxDate = input.data('max');
					}
					defaultDate = input.val();
				}

				$me.datepicker({
					dateFormat: "dd-mm-yy",
					minDate: (minDate != null) ? minDate : null,
					maxDate: (maxDate != null) ? maxDate : null,
					defaultDate: (defaultDate != null) ? defaultDate : null,
					nextText: '>',
					prevText: '<',
					showOtherMonths: true,
					selectOtherMonths: true,
					beforeShowDay: function(date) {
						let string = jQuery.datepicker.formatDate('yy-mm-dd', date);

						if(typeof ($me.data('disabled_dates')) !== "undefined") {
							if(disabledDays != null && disabledDays.indexOf(string) === -1) {
								return [ true, 'open', string ];
							} else if(closedDays != null && closedDays.indexOf(string) === -1) {
								return [ false, 'closed', string ];
							} else {
								return [ false, 'closed']; // disabled
							}
						} else {
							return [true, '', string];
						}
					},
					onSelect: function(date) {
						let params = {
							date: date
						};

						if($me.data('href')) {
							$.post($me.data('href'), params, function(response) {
								$($me.data('rc')).html( response );
							});
						}

						if($me.data('input')) {
							input = $("input[name='" + $(this).data('input') + "']");

							if( input.val() !== date ) {
								input.attr('value', date ).trigger('change');
							}
						}
					}
				});
			});
		}
	}

	function jQueryUI_slider() {
		if (typeof ($.fn.slider) === 'function') {
			let uis = $('.ui_slider');
			uis.each(function () {
				let $me = $(this);

				$(this).slider({
					range: "max",
					min: $me.data('min'),
					max: $me.data('max'),
					value: $me.data('val'),
					slide: function (event, ui) {
						$("div[data-pi='" + $me.data('pi') + "'] .amount").val(ui.value);
					},
					change: function (event, ui) {
						BART.Front.Util.createCookie('ldjn_rcap', ui.value);

						let params = {
							capacity: ui.value
						};

						$.post($me.data('href'), params, function (response) {
							$me.data('rc').html(response);
						});
					}
				});

				$("div[data-pi='" + $me.data('pi') + "'] .amount").val($(this).slider("value"));
			});
		}
	}

	function jQueryUI_autocomplete() {
		if (typeof ($.fn.autocomplete) === 'function') {
			let uiac = $('.autocomplete');
			uiac.each(function () {
				let $me = $(this);

				$me.autocomplete({
					delay: 300,
					minLength: 3,
					focus: function (event) { //event, ui
						event.preventDefault();
					},
					select: function (event, ui) {
						//Hier nog controle op PI??
						if ($(this).data('valuefield')) {
							$("input[name='" + $(this).data('valuefield') + "']").val(ui.item.id);
						}

						//Hier nog gedeeltelijke page refresh?
					},
					source: function (request, response) {
						$.ajax({
							url: $me.data('source'),
							method: 'GET',
							data: 'search=' + request.term,
							dataType: 'json',
							success: function (result) {
								response(result);
							},
							error: function () {
							}
						});
					}
				});
			});
		}
	}

	// OLD form validation js, deprecated
	function form_validation() {
		let forms = $('form').not('.exclude').not('.default-bootstrap-validation');
		forms.each(function() {
			let that = $(this);

			if (bootstrap_tpl) {


				/*
				$(this).formValidation().on('success.form.fv', function() {
					if ( $('#overlay').length ) {
						$("#overlay").show();
					}

				}).on('err.form.fv', function() {
					if (typeof $('.grid').masonry === "function") {
						$('.grid').masonry({
							columnWidth: 320,
							itemSelector: '.grid-item'
						});
					}
				}).on('success.field.fv', function() {

				}).on('err.field.fv', function() { //e, data
					if (typeof $('.grid').masonry === "function") {
						$('.grid').masonry({
							columnWidth: 320,
							itemSelector: '.grid-item'
						});
					}
				});

				//Nodig i.v.m. verversen losse html in tpl;
				that.find(':input').each(function() {
					if(!jQuery.isEmptyObject( $(this).data()) ) {
						if(typeof ($(this).data('fv-field')) !== "undefined") {
							//Options undefined, they are parsed from HTML attributes of field
							that.formValidation('addField', $(this).data('fv-field'));
						}
					}
				});*/

				// that.data('formValidation').resetForm(); //Als er na een POST nog validatie fouten zijn dan mag het formulier niet gereset worden.
			} else {
				if (typeof $(this).validate === "function") {
					$(this).validate();
				}

			}
		});
	}


	/**
	 * Revalidate specific input
	 * @param input {Element} input field to revalidate
	 *
	 */
/*	function revalidate(input) {

	}*/


	/**
	 * Form validation (new bootstrap 4 default)
	 *
	 * @return {void}
	 */
	function formValidation() {
		// custom-pattern
		let input_email = document.querySelector('input#email');
		let input_u_email = document.querySelector('input#u_email');
		let arr_input_email_for_validation = [
			document.querySelector('input#email'),
			document.querySelector('input#u_email'),
			document.querySelector('input#interest_email')
		];
		Array.prototype.forEach.call(arr_input_email_for_validation, function (el) {
			if (typeof (el) !== "undefined" && el != null) {
			// bij inputs type="email" van gemaakt	el.setAttribute("pattern", VUGRON.Main.constants.pattern_email);
			}
		});
/*		if (typeof (input_email) !== "undefined" && input_email != null) {
			input_email.setAttribute("pattern", VUGRON.Main.constants.pattern_email);
		}
		if (typeof (input_u_email) !== "undefined" && input_u_email != null) {
			input_u_email.setAttribute("pattern", VUGRON.Main.constants.pattern_email);
		}*/
		let custom_pattern_elems = document.querySelectorAll('[data-custom-pattern]');
		Array.prototype.forEach.call(custom_pattern_elems, function (el) {
			if (el.dataset.customPattern === "iban") {
				el.setAttribute("pattern", VUGRON.Main.constants.pattern_iban);
			}
		});

		// disabling form submissions if there are invalid fields
		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		var forms = document.getElementsByClassName('needs-validation');
		// Loop over them and prevent submission
		// eslint-disable-next-line no-unused-vars
		let validation = Array.prototype.filter.call(forms, function(form) {
			if ("liveValidation" in form.dataset) {

				// data-trigger-live-validation-from="country"
				/*let extraValidationTriggers = form.querySelectorAll('[data-trigger-live-validation-from]');
				if (extraValidationTriggers) {
					console.log('val trigger');
					Array.prototype.forEach.call(extraValidationTriggers, function (el) {
						let trigger = el.dataset.triggerLiveValidationFrom;
						let trigger_el = document.getElementById(trigger);
						if (typeof (trigger_el) !== "undefined" && trigger_el != null) {
							console.log('val triggerel:',trigger_el);
							trigger_el.addEventListener('change', function(evt) {
								console.log('trigger changed');
								_validate(evt, form, true);
							}, false);
						}
					});
				}*/

				// validate live
				form.addEventListener('change', function(evt) {
					// console.log('form changed');
					_validate(evt, form, true);
				}, false);
				form.addEventListener('keyup', function(evt) {
					// console.log('form keyup');
					_validate(evt, form, true);
				}, false);


			}
			// validate on submit
			form.addEventListener('submit', function(evt) {
				_validate(evt, form, false);
			}, false);
		});

		/**
		 * Validate form
		 *
		 * @param event {event} Triggered event from event listener
		 * @param form {Element} Form to validate
		 * @param liveValidation {boolean} Validate (every input on change|whole form on submit)
		 * @private
		 * @return {void}
		 */
		function _validate(event, form, liveValidation) {
			let e = event;
			let target = e.target;

			// if (target.dataset.toggleOtherValidity) {}
			let checkAcceptIncasso = document.getElementById("accept_incasso");
			let el_paymentMethod = (target.name != null && target.name === "payment_method") ? target : form.querySelector('[name="payment_method"]:checked');
			if (el_paymentMethod != null) {
				if (typeof (checkAcceptIncasso) !== "undefined") {
					let checkAcceptIncassoWrapper = checkAcceptIncasso.closest(".form-group");
					if (el_paymentMethod.value && el_paymentMethod.value.toLowerCase() !== "factuur") {
						checkAcceptIncasso.setAttribute('required', 'required');
						if (typeof (checkAcceptIncassoWrapper) !== "undefined" && checkAcceptIncassoWrapper != null) {
							checkAcceptIncassoWrapper.style.display = "block";
						}
					} else {
						checkAcceptIncasso.removeAttribute('required');
						if (typeof (checkAcceptIncassoWrapper) !== "undefined" && checkAcceptIncassoWrapper != null) {
							checkAcceptIncassoWrapper.style.display = "none";
						}
					}
					_toggleInvalidClasses(checkAcceptIncasso);
				}
			}

			if (liveValidation) {
				_toggleInvalidClasses(target);
			}

			// compare password fields for same value
			let password = form.querySelector('[name="password"]');
			let password2 = form.querySelector('[name="password2"]');
			if (password != null && password2 != null) {
				let pw_invalid_block = form.querySelector('[name="password2"] ~ .invalid-feedback');
				let str_err_msg = password2.value !== password.value ? "De wachtwoorden komen niet overeen." : "";
				password2.setCustomValidity(str_err_msg);
				if (pw_invalid_block != null) {
					pw_invalid_block.textContent = str_err_msg;
				}
			}

			if (e.type === "submit") {
				if (form.checkValidity() === false) {
					e.preventDefault();
					e.stopPropagation();
					let validateInputs = form.querySelectorAll("[required]");
					let _b_scrolled = false;
					Array.prototype.forEach.call(validateInputs, function (el) {
						if (el.offsetParent !== null && el.validity && el.validity.valid === false) {
							if (!_b_scrolled) {
								el.parentNode.scrollIntoViewIfNeeded(true);
								_b_scrolled = true;
							}
							_toggleInvalidClasses(el);
						}
					});
				}
				form.classList.add('was-validated');
			}


			/**
			 * Toggle invalid classes
			 * @param el {Element} Element to toggle invalid classes
			 * @private
			 * @return {void}
			 */
			function _toggleInvalidClasses(el) {
				if(typeof el.checkValidity === 'function') {
					// TODO get all siblings and toggle is-invalid class (for proper radio button live validation)
					if (el.checkValidity() === false) {
						if (el.parentNode.classList.contains("invalid-pointer")) {
							el.parentNode.classList.add('is-invalid');
						}
						el.classList.add("is-invalid");
					} else {
						if (el.parentNode.classList.contains("invalid-pointer")) {
							el.parentNode.classList.remove('is-invalid');
						}
						el.classList.remove("is-invalid");
					}
				}
			}
		}
	}

	/**
	 * Create modal
	 *
	 * @param headerNode {String|null} Modal header
	 * @param textNode {String|Object|null} Modal body text
	 * @param btn_approve_text {String|null} Modal apply button text
	 * @param btn_cancel_text {String|null} Modal cancel button text
	 * @param callback_approve {Function|null} Callback function on apply button click
	 * @param callback_cancel {Function|null} Callback function on cancel
	 * @param b_keep_modal_on_cancel {Boolean|null} Keep modal on cancel button click
	 * @return {void}
	 */
	function createModal(headerNode, textNode, btn_approve_text, btn_cancel_text, callback_approve, callback_cancel, b_keep_modal_on_cancel) {
		let modalwrap = document.createElement("div");
		modalwrap.id = "open-modal";
		modalwrap.classList.add("modal-window");
		modalwrap.classList.add("visible");

		let modal = document.createElement("div");
		modal.id = 'innermodal';
		let modalContent = document.createElement("div");
		modalContent.id = 'modalcontent';
		let modal_close_btn = document.createElement("button");
		modal_close_btn.classList.add("modal-close");
		modal_close_btn.id = "modal-close";
		modal.appendChild(modal_close_btn);

		if (headerNode != null) {
			_createModalTxtElem("h1", null,headerNode+"\n", modalContent);
		}

		if (textNode != null) {
			if (typeof textNode === "string") {
				_createModalTxtElem("p", null, textNode+"\n", modalContent);
			}
			if (typeof textNode === "object") {
				Object.keys(textNode).forEach(function (item, index, arr) {
					if (Object.is(arr.length - 1, index)) {/*...*/}
					if (typeof (textNode[item]) !== 'undefined' && textNode[item] !== null) {
						let currTxtTitle = item;
						let currTxtNode = textNode[item];
						_createModalTxtElem("p", currTxtTitle, currTxtNode+"\n", modalContent);
					}
				});
			}
		}

		let button_wrap = document.createElement("div");
		button_wrap.classList.add("buttonwrap");

		if (btn_approve_text != null) {
			_createModalBtnElem("modal_approve", btn_approve_text, button_wrap);
		}
		if (btn_cancel_text != null) {
			_createModalBtnElem("modal_cancel", btn_cancel_text, button_wrap);
		}

		modal.appendChild(modalContent);
		modal.appendChild(button_wrap);
		modalwrap.appendChild(modal);
		document.body.appendChild(modalwrap);

		(function evtHandlers() {
			let btn_approve_el = document.getElementById('modal_approve');
			let btn_cancel_el = document.getElementById('modal_cancel');
			let closebtn = document.getElementById('modal-close');
			let innermodal = document.getElementById('innermodal');
			$(".modal-window").on('click', function(e) {
				if (e.target === btn_approve_el || e.target === btn_cancel_el || e.target === closebtn || (e.target !== innermodal) && (e.target.offsetParent !== innermodal)) {
					if (typeof callback_approve === "function" && e.target === btn_approve_el) {
						callback_approve();
					}
					// if (typeof callback_cancel === "function" && e.target !== btn_approve_el) {
					if (typeof callback_cancel === "function" && e.target === btn_cancel_el) {
						callback_cancel();
					}
					if (!b_keep_modal_on_cancel || e.target !== btn_cancel_el) {
						$("#open-modal").remove();
					}
				}
			});
		})();

		function _createModalTxtElem(el_type, titleNode, textNode, appendToElem) {
			let elemType = document.createElement(el_type);
			let elemText = document.createTextNode(textNode);
			/*			Array.prototype.forEach.call(arr_extraElemNodesToAppend, function (el) {
                            elemType.appendChild(el);
                        });*/
			if (titleNode != null) {
				let titleType = document.createElement('span');
				let titleText = document.createTextNode(titleNode);
				titleType.className = 'txt-title';
				titleType.appendChild(titleText);
				elemType.appendChild(titleType);
				let elemSubType = document.createElement('span');
				elemSubType.className = 'txt-body';
				elemSubType.appendChild(elemText);
				elemType.appendChild(elemSubType);
			} else {
				elemType.appendChild(elemText);
			}
			appendToElem.appendChild(elemType);
		}

		function _createModalBtnElem(id, text, appendToElem) {
			let button = document.createElement("button");
			button.value = text;
			button.id = id;
			let btn_textContent = document.createTextNode(text);
			button.appendChild(btn_textContent);
			appendToElem.appendChild(button);
		}
	}

	function fallbackCopyTextToClipboard(text) {
		let textArea = document.createElement("textarea");
		textArea.value = text;
		document.body.appendChild(textArea);
		// textArea.focus();
		textArea.select();

		try {
			let successful = document.execCommand('copy');
			let msg = successful ? 'successful' : 'unsuccessful';
			console.log('Fallback: Copying text command was ' + msg);
		} catch (err) {
			console.error('Fallback: Oops, unable to copy', err);
		}

		document.body.removeChild(textArea);
	}

	function copyTextToClipboard(text) {
		if (!navigator.clipboard) {
			fallbackCopyTextToClipboard(text);
			return;
		}
		navigator.clipboard.writeText(text).then(function() {
			console.log('Async: Copying to clipboard was successful!');
		}, function(err) {
			console.error('Async: Could not copy text: ', err);
		});
	}

	function calculateAge(birthday) {
		var dateParts = birthday.split("-");
		var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

		var now = new Date();
		var current_year = now.getFullYear();
		var year_diff = current_year - dateObject.getFullYear();
		var birthday_this_year = new Date(current_year, dateObject.getMonth(), dateObject.getDate());
		var has_had_birthday_this_year = (now >= birthday_this_year);

		return has_had_birthday_this_year
			? year_diff
			: year_diff - 1;
	}

	function calculate_price(birth_date, cursusid) {	// birthdate, het in 'data' plaatsen had mankementen af en toe
		let $calcprice = $("#calc_price");

		if($calcprice.data('href') && $("#calc_price").data('amount_lessons') !== 'tl' ) {
			let params = {
				cursusid: cursusid !== undefined ? cursusid : $("#calc_price").data('cursus_id'),
				county_id: $("#calc_price").data('county_id'),
				birth_date: birth_date === undefined ? $("#calc_price").data('birth_date') : birth_date,	//$("#calc_price").data('amount_lessons') === 'tl' ? $("#trial_lesson_birthdate").val() : $("#calc_price").data('birth_date')
				student: $('#student').is(":checked") ? 'on' : 'off',
				student_nr: $('#student').is(":checked") ? $("#student_nr").val() : '',
				librarymember: $('input[name="librarymember"]:checked').val(),
				// librarymember_number: $('#librarymember').is(":checked") ? $("#librarymember_number").val() : '',
				req_startdate: $("#calc_price").data('req_startdate'),
				amount_lessons: $("#calc_price").data('amount_lessons'),
				lesson_duration: $("#calc_price").data('lesson_duration'),	//($('input[name="lessonduration_id"]').data('lessonduration') == '2030' ? '2030' : $("#calc_price").data('lesson_duration')),
				lessonduration_id: $("#calc_price").data('lessonduration_id')
			};

			let result;
			$.post($calcprice.data('href'), params, function(response) {
				if(typeof response === 'string' && response.indexOf('{') !== -1) {
					result = JSON.parse(response);
				}

				if(result.success) {
					if(result.county !== '') {
						$("#county_fld").html( result.county );
					}

					if(result.age != null) {
						$("#age_fld").html( result.age );
					}

					if(result.county !== '' || result.age != null || result.student_nr != null || (result.rato != null && result.rato < 1)) {
						$(".pricecalculated").show();

						if(result.price !== "0,00") {
							if( $("#year_price_fld").length > 0 ) {
								$("#price_fld").html( '&euro; ' + result.price );// + (result.yearprice !== undefined ? ' (jaartarief: &euro; '+result.yearprice+')' : ''));
							} else {
								$("#price_fld").html( '&euro; ' + result.price + (result.yearprice !== undefined ? ' (jaartarief: &euro; '+result.yearprice+')' : ''));
							}
						} else {
							$("#price_fld").html( 'Gratis' );
						}

						if( $("#year_price_fld").length > 0 ) {
							if (result.yearprice !== undefined) {
								$("#year_price_fld").html('(jaartarief: &euro; ' + result.yearprice + ')');
							} else {
								$("#year_price_fld").html('');
							}
						}

						if(result.inst_amount <= 0) {
							$("#installment").hide();
						} else {
							$("#installment").show();
							$("#installments").html( result.installments );
							$("#inst_amount").html( result.inst_amount );
						}

						if(result.inst_amount2 <= 0) {
							$("#installment2").hide();
						} else {
							$("#installment2").show();
							$("#installments2").html( result.installments2 );
							$("#inst_amount2").html( result.inst_amount2 );
						}
					}

					if (typeof $(".grid").masonry === "function") {
						$(".grid").masonry({
							columnWidth: 320,
							itemSelector: '.grid-item'
						});
					}
				} else {
					//An error occured
					$("#price_fld").html( '&euro;' );
					$("#installment").hide();
					$("#installment2").hide();
				}
			});
		}
	}

	function update_schedule(callback) {
		if ($("#schedule").data('href')) {
			$("#overlay").show();

		var params = {
				who: $('input[name="who"]:checked').val(),
				cursusid: $('input[name="cursusid"]').val(),
				prev_amount_lessons: $('input[name="prev_amount_lessons"]').val(),
				amount_lessons: $('input[name="amount_lessons"]:checked').val(),
				prev_lesson_duration: $('input[name="prev_lesson_duration"]').val(),
				lesson_duration: $('input[name="lesson_duration"]').attr('type') === 'radio' ? $('input[name="lesson_duration"]:checked').val() : $('input[name="lesson_duration"]').val(),
				prev_lessonduration_id: $('input[name="prev_lessonduration_id"]').val(),
				lessonduration_id: $('input[name="lessonduration_id"]').attr('type') === 'radio' ? $('input[name="lessonduration_id"]:checked').val() : $('input[name="lessonduration_id"]').val(),
				prev_req_startdate: $('input[name="prev_req_startdate"]').val(),
				req_startdate: $('input[name="req_startdate"]').val(),
				req_time: $('input[name="req_time"]:checked').val(),
				teacher_id: $('select[name="teacher_id"]').length > 0 ? $('select[name="teacher_id"] option:selected').val() : $('input[name="teacher_id"]').attr('type') === 'radio' ? $('input[name="teacher_id"]:checked').val() : $('input[name="teacher_id"]').val(),
				selected_course: $('input[name="selected_course"]:checked').val(),
				county_id: $("#calc_price").data('county_id'),
				birth_date: $("#calc_price").data('birth_date'),
				student: $('#student').is(":checked") ? 'on' : 'off',
				student_nr: $('#student').is(":checked") ? $("#student_nr").val() : '',
				paymentmethod: $('input[name="paymentmethod"]').attr('type') === 'radio' ? $('input[name="paymentmethod"]:checked').val() : $('input[name="paymentmethod"]').val(),
				bank_account: $('input[name="bank_account"]').val(),
				comments: $('textarea[name="comments"]').val()
			};

			if (params.who === 'someone_else') {
				params.name = $('input[name="name"]').val();
				params.infix = $('input[name="infix"]').val();
				params.lastname = $('input[name="lastname"]').val();
				params.gender = $('input[name="gender"]:checked').val();
				params.country = $('input[name="country"]:checked').val();
				params.postcode = $('input[name="postcode"]').val();
				params.housenumber = $('input[name="housenumber"]').val();
				params.telephone = $('input[name="telephone"]').val();
				params.email = $('input[name="email"]').val();
				params.birth_date = $('input[name="birth_date"]').val();
			}

			$.post($("#schedule").data('href') + '&smarty=yes&pida=yes', params, function (response) {
				$("#schedule").html(response);

				// Initialize range sliders
				if (typeof $('input.range-slider').rangeslider === "function") {
					$("input.range-slider").rangeslider({
						polyfill: false
					});
				}

				let country_val = $("select#country").val();
				let $postcode = $('#postcode');
				let $iban = $('[data-custom-pattern="iban"]');

				if(country_val === 'DE') {
					$postcode
						.attr('pattern', VUGRON.Main.constants.pattern_zip_DE)
						.next('.invalid-feedback').text(VUGRON.Main.constants.zip_message_DE);
				} else if(country_val === 'NL') {
					$postcode
						.attr('pattern', VUGRON.Main.constants.pattern_zip_NL)
						.next('.invalid-feedback').text(VUGRON.Main.constants.zip_message);
				} else if(country_val === 'BE') {
					$postcode
						.attr('pattern', VUGRON.Main.constants.pattern_zip_BE)
						.next('.invalid-feedback').text(VUGRON.Main.constants.zip_message);
				}

				VUGRON.Main.jQueryUI_datepicker();
				VUGRON.Main.form_validation();

				if (typeof $(".grid").masonry === "function") {
					$(".grid").masonry({
						columnWidth: 320,
						itemSelector: '.grid-item'
					});
				}

				if ($('input[name="who"]').length) {
					$('input[name="who"]').change();
				}

				//Er moet altijd tenminste 1 betaalmethode aangevinkt zijn
				if ($('input[name="paymentmethod"]').length) {
					if( !$('input[name="paymentmethod"]').is(':checked') ) {
						$('input[name="paymentmethod"]:first').attr('checked', true);
					}
					$('input[name="paymentmethod"]').change();
				}

				if ($('#housenumber').length && $('#housenumber').val() !== "") {
					$('#housenumber').focus();
					$('#housenumber').blur();
				}

				if(callback !== undefined) {
					callback.call();
				}

				$("#overlay").hide();

				VUGRON.Main.set_datepickers();
				VUGRON.Main.set_tooltips();
			});
		}
	}

	function set_datepickers() {
		$('.add_datepicker').datepicker({
			dateFormat: "dd-mm-yy",
			changeYear: true,
			maxDate: "-1",
			nextText: '>',
			prevText: '<',
			yearRange: "-100:+0",
			showOtherMonths: true,
			selectOtherMonths: true,
			onSelect: function () { //date
				// $(this).closest('form')
				// 	.formValidation('updateStatus', 'birth_date', 'NOT_VALIDATED')
				// 	.formValidation('validateField', 'birth_date');
			}
		});
		$('#birth_date').datepicker({
			dateFormat: "dd-mm-yy",
			changeYear: true,
			maxDate: "-1",
			nextText: '>',
			prevText: '<',
			yearRange: "-100:+0",
			showOtherMonths: true,
			selectOtherMonths: true,
			defaultDate: '1979-04-17',
			onClose: function() {
				$(this).trigger('change');
				// this.focus();
				// this.blur();
				triggerEvent(this, 'keydown');
				triggerEvent(this, 'change');
				VUGRON.Main.formValidation();
				$('#calc_price').data('birth_date', $(this).val());

				if(typeof ($(this).data('cp')) === "undefined" || $(this).data('cp') === true) {
					VUGRON.Main.calculate_price();
				}
			},
			onSelect: function() {
				$('#birth_date').trigger('change');
				triggerEvent(this, 'keydown');
				triggerEvent(this, 'change');
				$(this).closest('form').trigger('change');
				VUGRON.Main.formValidation();
				// .formValidation('updateStatus', 'birth_date', 'NOT_VALIDATED')
					// .formValidation('validateField', 'birth_date');
			}
		});
		$('#req_startdate').datepicker({
			dateFormat: "dd-mm-yy",
			changeYear: true,
			// minDate: "+2w",
			// maxDate: "31-08-2017",
			beforeShow: function () { //input, inst
				$(this).datepicker('option', 'minDate', $(this).data('min'));
				$(this).datepicker('option', 'maxDate', $(this).data('max'));
			},
			onSelect: function () {//date
				$('#calc_price').data('req_startdate', $(this).val());
				VUGRON.Main.calculate_price();
			},
			beforeShowDay: function (date) {
				var unavailableDates = ["30-08-2018"];	//$(this).data('exclude');
				var string = jQuery.datepicker.formatDate('dd-mm-yy', date);
				return [$.inArray(string, unavailableDates) === -1];
			}
		});
	}

	function set_tooltips() {
		$('.info-tooltip').tooltip({
			title: function() {
				return $(this).find(".tooltip").text();
			}
		});
	}

	function autoExecPageLoad() {
		VUGRON.Main.set_tooltips();
		VUGRON.Main.formValidation();
		let bootstrap_tpl = $body.hasClass('bootstrap_tpl');
		$('input[name="customer_type"]').trigger( "change" );
		$(".mod_vugron .provider form .submit").hide();


		// console.log('exec pageload init..');

		/*if ( $('input[name="who"]').length ) {
			console.log('who length...');
			$('input[name="who"]').change();
		}*/
		if (typeof $(".grid").masonry !== "function") { //Als NIET oude kumulus tpl
			$('input[name="student"]').change(function() {
				if($(this).prop('checked')) {
					$('#collapseStudent').show({
						duration: 400
					});
					if($('input[name="student_nr"]').val() !== '') {
						VUGRON.Main.calculate_price();
					}
				} else {
					$('#collapseStudent').hide();
					VUGRON.Main.calculate_price();
				}
			});
		}
		$('input[name="student_nr"]').focusout(function() {
			// if( $(this).val() != '') {
			if (typeof $(".grid").masonry === "function") { //Als oude kumulus tpl
				VUGRON.Muziekschool.Main.calculate_price();
			}
			// }
		});
		if (bootstrap_tpl) {
			$('#collapseStudent').collapse().on('shown.bs.collapse', function () {
				if (typeof $(".grid").masonry === "function") {
					$(".grid").masonry({
						columnWidth: 320,
						itemSelector: '.grid-item'
					});
				}
			}).on('hidden.bs.collapse', function () {
				if (typeof $(".grid").masonry === "function") {
					$(".grid").masonry({
						columnWidth: 320,
						itemSelector: '.grid-item'
					});
				}
			});
		} else {
			//Hier alternatief voor collapse (show/hide)?
		}
		if ( $(".mod_vugron .register").length ) {
			$(".nostudent").hide();

			//calculate_price();
		}
		// er moet altijd tenminste 1 betaalmethode aangevinkt zijn
		if ( !$("input:radio[name=ptype]").is(':checked') ) {
			$("input:radio[name=ptype]:first").attr('checked', true);
		}
		$('input[type=radio][name=ptype]').change();

		// er moet altijd tenminste 1 betaalmethode aangevinkt zijn
		if ( !$("input:radio[name=paymentmethod]").is(':checked') ) {
			$("input:radio[name=paymentmethod]:first").attr('checked', true);
		}
		$('input[type=radio][name=paymentmethod]').change();

		if ( $(".mod_vugron .cart_edit form").length ) {
			$('#betaal_knoppen').show();
		}
		if ( $(".mod_vugron .cart_summary form").length ) {
			$('#betaal_knoppen').show();
		}

	}


	/**
	 * Expand related items PDP
	 */
	function toggleRelatedItems() {
		let $meerinfoWrapper = $('.search-result-items.related-copies-list .row');
		if ($meerinfoWrapper !== null) {
			let str_more_results = "Meer resultaten";
			let str_less_results = "Minder resultaten";
			let firstItemHeight = $meerinfoWrapper.find("> *").first().outerHeight();
			// show 2 rows in viewports >= 768, show 3 rows in smaller viewports : $(window).width() >= 768 ? (firstItemHeight * 2) : (firstItemHeight * 3)
			let maxHeight = (firstItemHeight * 2);
			let initheight = $meerinfoWrapper.height();
			if (initheight > maxHeight) {
				$meerinfoWrapper
					.css("height", maxHeight + "px")
					.addClass('expandable')
					.append("<div class='gradient'></div>")
					.parent().append("" +
					"<div class='more-info-wrap'>" +
					"<a href='#' class='toggle_height_related_items'>" +
					"<i class=\"fas fa-angle-double-down rotate-active px-1 ml-n1\"></i>" +
					"<span class='toontext'>" + str_more_results + "</span>" +
					"</a>" +
					"</div>" +
					"");
				let $readMore = $(".toggle_height_related_items");
				$readMore.on("click", function (e) {
					e.preventDefault();
					$meerinfoWrapper.toggleClass('active');
					$(".rotate-active").toggleClass('active');
					$(".toontext").text(function() {
						return $(this).text().indexOf(str_more_results) > -1  ? str_less_results : str_more_results;
					});
					$($meerinfoWrapper).animate({
						height: $meerinfoWrapper.hasClass('active') ? initheight : maxHeight
					}, "normal");
				});
			}
		}
	}


	return {
		constants: constants,
		init: init,
		normalize: normalize,
		jQueryUI_datepicker: jQueryUI_datepicker,
		jQueryUI_slider: jQueryUI_slider,
		jQueryUI_autocomplete: jQueryUI_autocomplete,
		form_validation: form_validation,
		formValidation: formValidation,
		/*revalidate: revalidate,*/
		createModal: createModal,
		fallbackCopyTextToClipboard: fallbackCopyTextToClipboard,
		copyTextToClipboard: copyTextToClipboard,
		calculate_price: calculate_price,
		update_schedule: update_schedule,
		set_datepickers: set_datepickers,
		set_tooltips: set_tooltips,
		calculateAge: calculateAge
	}
}(jQuery);


//@DOM ready
$(function() {
	VUGRON.Main.init();

	let $body = $('body');
	let $calcprice = $("#calc_price");
	let bootstrap_tpl = $body.hasClass('bootstrap_tpl');

/*
	// Add visible state for custom select-list of filter selection
	$('body').on('click', '.custom-select', function(e) {
		e.stopPropagation();

		if($("body").hasClass("select-opened")) {
			$(".select-list", this).hide();
			$(this).removeClass("opened");
			$("body").removeClass("select-opened");
		} else {
			$(".select-list", this).show();
			$(this).addClass("opened");
			$("body").addClass("select-opened");
		}
	});

	// Close custom select list of dropdown, when an option is clicked
	$('body').on('click', '.custom-select .select-list .option', function(e) {
		e.stopPropagation();
	});

	// Add visible state for custom select-list of dropdown
	$('body').on('click', '.custom-dropdown, .custom-dropdown-small', function(e) {
		e.stopPropagation();

		if($("body").hasClass("dropdown-opened")) {
			$(".select-list", this).hide();
			$(this).removeClass("opened");
			$("body").removeClass("dropdown-opened");
		} else {
			$(".select-list", this).show();
			$(this).addClass("opened");
			$("body").addClass("dropdown-opened");
		}
	});

	// Close custom select list of dropdown, when body is clicked
	$("body").on('click', function() {
		if($(this).hasClass("dropdown-opened")) {
			$(this).find(".custom-dropdown.opened .select-list, .custom-dropdown-small.opened .select-list").hide();
			$(this).find(".custom-dropdown.opened, .custom-dropdown-small.opened").removeClass("opened");
			$("body").removeClass("dropdown-opened");
		} else if($(this).hasClass("select-opened")) {
			$(this).find(".custom-select.opened .select-list").hide();
			$(this).find(".custom-select.opened").removeClass("opened");
			$("body").removeClass("select-opened");
		}
	});

	// Change value of select-field and close custom select list of dropdown, when an option is clicked
	$('body').on('click', '.custom-dropdown .select-list .option, .custom-dropdown-small .select-list .option', function(e) {
		e.stopPropagation();
		var text = $(this).text();
		var value = $(this).data('val');
		var current = $(this).parent().siblings(".current");
		var select = $(this).parent().siblings(".default-select");

		$("body").find(".custom-dropdown.opened .select-list, .custom-dropdown-small.opened .select-list").hide();
		$("body").find(".custom-dropdown.opened, .custom-dropdown-small.opened").removeClass("opened");
		$("body").removeClass("dropdown-opened");

		current.html(text);
		select.val(value);
		select.change();

		if( select.data('url') != undefined) {
			if(value != '') {
				window.location.href = select.data('url') + '?sec=' + value;
			} else {
				window.location.href = select.data('url');
			}
		} else {
			if( select.attr("name") == 'teacher_id' ) {
				//Update href of 'teacher info' link
				if($("body").find(".teacher a.info")) {
					href = $("body").find(".teacher a.info").data('href');
					href += value;

					if(href.indexOf("?") === -1) {
						text = text.replace(" ", "-");
						text = text.replace("/", "-");
						href += '.' + text + '.html'
					}
					$("body").find(".teacher a.info").attr("href", href);
				}
			}
		}
	});*/


	/*  console.log( event.type );    // The event type, eg. "click"
    console.log( event.which );   // The button or key that was pressed.
    console.log( event.target );  // The originating element.
    console.log( event.pageX );   // The document mouse X coordinate.
    console.log( event.pageY );   // The document mouse Y coordinate.*/

	//Andre, wordt dit goed gedaan in php? anders dit aanzetten?   $( "#trial_lesson_birthdate" ).change(function(a) {
	// 	// als leeftijd jonger is dan de aanbiederinstelling dan foutmelding en zeggen dat ze moeten inloggen
	// 	let student_age = VUGRON.Main.calculateAge($(this).val());
	//
	// 	if(student_age < $(this).data('minDebtorAge')) {
	// 		// alert('De cursist is jonger dan 18. Log in en kies bij de aanmelding het kind waar de proefles voor bestemd is.');
	// 		// window.location.href = 'https://' + $(this).data('loginUrl');
	// 	}
	// });

	$('input[name="search"]').on('focus', function(e) {
		if(this.value == "" || this.value == this.placeholder) {
			this.dataset.placeholder = this.placeholder;
			this.placeholder = '';
		}
	});

	$('input[name="search"]').on('blur', function(e) {
		this.placeholder = this.dataset.placeholder;
	});

	$body.on('change click', function(e) {
		let $target = $(e.target);
		let $librarymember = $('input[name="librarymember"]');
		let $calcPrice = $('.calc_price');
		let $county_id = $("#county_id");
		let $customerType = $('input[name="customer_type"]');
		let $who = $('input[name="who"]');
		let $inputBtn = $('input.btn');
		let $addToCart = $("a.add_to_cart");
		let $addToCart2 = $("a.add_to_cart2");
		let $primaryBtnDisabled = $("a.primary.button.disabled");
		let $address = $('.address');
		let $removeFromCart = $("a.remove_from_cart");
		let $radioPtype = $("input[type=radio][name=ptype]");
		let $radioPaymentmethod = $("input[type=radio][name=paymentmethod]"); // only for biblionet?
		let $selectAantal = $(".row.item select[name='aantal']");
		let $selectPerson = $(".row.item select.person");
		let $country = $('#country');
		let $amount = $('select[name="amount"]');
		let $sort = $('select[name="sort"]');
		let $customer_type = $('select[name="customer_type"]');
		let $ctype = $('select[name="ctype"]');
		let $plaats = $('select[name="plaats"]');
		let $tloc = $('select[name="tloc"]');
		let $location_id = $('select[name="location_id"]');
		let $age = $('select[name="age"]');
		let $agid = $('select[name="agid"]');
		let $wgid = $('select[name="wgid"]');
		let $amount_lessons = $('input[name="amount_lessons"]');
		let $teacher_id = $('input[name="teacher_id"]');
		let $selected_course = $('input[name="selected_course"]');
		let $selected_course_checked = $('input[name="selected_course"]:checked');
		let $req_time = $('input[name="req_time"]');
		let $lesson_duration = $('input[name="lesson_duration"]');
		let $lessonduration_id = $('input[name="lessonduration_id"]');
		let $req_startdate = $('input[name="req_startdate"]');
		let $birth_date = $('input[name="birth_date"]');
		let $basketEditSelectGroupId = $('.basket.edit select.group_id');
		let $toggleItems = $("[data-trigger='toggle-times']");
		let $basketSelectNumberItems = $('.basket select[name="number_of_items"]');
		let $basketEditAdd = $(".basket.edit a.add");
		let $basketEditItemsRemove = $(".basket.edit .items a.remove");
		let $basketItemsRemove = $(".basket .items a.remove");
		let $field_why_us = $('select[name="field_why_us_selected"]');
		let $iban = $('input[name="bank_account"]');

		if (e.type === "click") {
			if ($target.is($librarymember)) {
				VUGRON.Main.calculate_price();
			}
			if ($target.is($calcPrice)) {
				VUGRON.Main.calculate_price();
			}

			// Edge
			if($target.is($field_why_us)) {
				var valueSelected  = $field_why_us.find(":selected").val();

				if(valueSelected.toLowerCase().indexOf('anders') >= 0 || valueSelected.toLowerCase().indexOf('*') >= 0 || valueSelected.toLowerCase().indexOf('namelijk') >= 0) {
					$('#field_why_us_anders_option').show();
				} else {
					$('#field_why_us_anders_option').hide();
				}
			}

			if ($target.is($inputBtn)) {
				if(typeof ($(this).data('wait')) !== "undefined") {
					$('#overlay .wait span').html( $(this).data('wait') );
				}
			}
			if ($target.is($addToCart)) {
				let provider_id = $(this).data('provider');
				$.get($(this).attr('href'), function(response) {
					let result = JSON.parse(response);
					if(result.success) {
						if($(".winkelwagen_status span.badge").length ) {
							$(".winkelwagen_status span.badge").removeClass('d-none');
							$('.winkelwagen_status span.badge').html( result.data.cnt_products );
						} else {
							$('.winkelwagen_status').html('Uw winkelwagen bevat '+result.data.cnt_products+' item' + (result.data.cnt_products > 1 ? 's' : ''));
						}
						$('#fb_alert .msg').html( result.data.message );

						// todo: removed class added directly again, really necessary?
						$('#myModal .modal-body').removeClass( "text-danger" ).removeClass( "text-success" );
						$('#myModal .modal-body').addClass( "text-success" );

						// todo: removed class added directly again, really necessary?
						$('#myModal .modal-footer .btn').removeClass( "btn-default" ).removeClass( "btn-success" ).removeClass( "btn-danger" );
						$('#myModal .modal-footer .btn').addClass( "btn-success" );

						$('#myModal .modal-body').html( result.data.message );
					} else {
						$('#fb_alert .msg').html( result.errors.message );

						// todo: removed class added directly again, really necessary?
						$('#myModal .modal-body').removeClass( "text-danger" ).removeClass( "text-success" );
						$('#myModal .modal-body').addClass( "text-danger" );

						// todo: removed class added directly again, really necessary?
						$('#myModal .modal-footer .btn').removeClass( "btn-default" ).removeClass( "btn-success" ).removeClass( "btn-danger" );
						$('#myModal .modal-footer .btn').addClass( "btn-danger" );

						$('#myModal .modal-body').html( result.errors.message );
					}
					// Bootstrap
					if (bootstrap_tpl) {
						$('#myModal').modal('show');
					} else {
						$.fancybox({
							'padding': 0,
							'margin': 0,
							'autoDimensions': true,
							'enableEscapeButton': false,
							'showCloseButton': false,
							'transitionIn': 'none',
							'transitionOut': 'none',
							'content': $('#fb_alert').html(),
							'onStart': function() {
								$('#fancybox-outer').css({
									'background': 'transparent'
								});
								$('#fancybox-bg-n,#fancybox-bg-ne,#fancybox-bg-e,#fancybox-bg-se,#fancybox-bg-s,#fancybox-bg-sw,#fancybox-bg-w,#fancybox-bg-nw').css({
									'background-image': 'none'
								});
							}
						});

						$("a.close_alert").click(function() {
							$.fancybox.close();
							if(!result.success) {
								window.location.href = result.errors.redirect;
							} else if(result.data.on_add_goto_cart === 'on') {
								window.location.href = result.data.redirect;
							}
						});
					}
					//Show info-icon
					$('a.add_to_cart:not([data-provider="' + provider_id + '"])').next('a.info-tooltip').removeClass('hidden');
					$('a.primary.button.hidden').removeClass('hidden');
					//Disable other shoppingcart link for other providers
					$('a.add_to_cart:not([data-provider="' + provider_id + '"])').addClass('disabled').removeClass('add_to_cart').removeAttr("href").unbind("click");
				});
				return false;
			}
			if ($target.is($addToCart2)) {
				$("#overlay").show();

				let l = $(".courses > div.card").length;
				let i = $(".card").index( this.closest( ".card" ) );

				$.get($(this).attr('href') + '&smarty=yes&pida=yes', function(response) {
					let result = JSON.parse(response);

					let $modalbody = $('#myModal .modal-body');
					let $modalfooterBtn = $('#myModal .modal-footer .btn');
					if (result.success) {
						if ($(".winkelwagen_status span.badge").length) {
							$(".winkelwagen_status span.badge").removeClass('d-none');
							$('.winkelwagen_status span.badge').html(result.data.cnt_products);
						} else {
							$('.winkelwagen_status').html('Uw winkelwagen bevat ' + result.data.cnt_products + ' item' + (result.data.cnt_products > 1 ? 's' : ''));
						}

						// $(".courses .rc").append( result.data.html );
						$(".courses").append(result.data.html);

						//Scroll naar toegevoegde cursus; scroll snelheid wordt uitgerekend.
						$('html, body').animate({
							scrollTop: $('.item_' + result.data.cart_item_id).offset().top
						}, (l - i) * 250);

						$("#overlay").hide();
					} else {
						$('#fb_alert .msg').html(result.errors.message);

						// todo: removed class added directly again, really necessary?
						$modalbody.removeClass("text-danger").removeClass("text-success");
						$modalbody.addClass("text-danger");

						// todo: removed class added directly again, really necessary?
						$modalfooterBtn.removeClass("btn-default").removeClass("btn-success").removeClass("btn-danger");
						$modalfooterBtn.addClass("btn-danger");

						$modalbody.html(result.errors.message);

						// Bootstrap
						if (bootstrap_tpl) {
							$('#myModal').modal('show');
						} else {
							$.fancybox({
								'padding': 0,
								'margin': 0,
								'autoDimensions': true,
								'enableEscapeButton': false,
								'showCloseButton': false,
								'transitionIn': 'none',
								'transitionOut': 'none',
								'content': $('#fb_alert').html(),
								'onStart': function () {
									$('#fancybox-outer').css({
										'background': 'transparent'
									});
									$('#fancybox-bg-n,#fancybox-bg-ne,#fancybox-bg-e,#fancybox-bg-se,#fancybox-bg-s,#fancybox-bg-sw,#fancybox-bg-w,#fancybox-bg-nw').css({
										'background-image': 'none'
									});
								}
							});

							$("a.close_alert").click(function () {
								$.fancybox.close();
								if (!result.success) {
									window.location.href = result.errors.redirect;
								} else if (result.data.on_add_goto_cart === 'on') {
									window.location.href = result.data.redirect;
								}
							});
						}
					}
				});

				return false;
			}
			if ($target.is($primaryBtnDisabled)) {
				return false;
			}
			if ($target.is($removeFromCart)) {
				$.get($(this).attr('href'), function(response) {
					let result = JSON.parse(response);

					if(result.success) {
						$('.cart .item_'+result.data.item).remove();
						$('.cart .item_promocode_'+result.data.item).remove();
						$('.course.item_'+result.data.item).remove();

						if(result.data.total_count === 0) {
							$('.cart_info a.primary.button').addClass('hidden');
							$('.mod_vugron .cart_summary').html( '<p>Uw winkelwagentje is leeg</p>' );

							if($(".winkelwagen_status span.badge").length ) {
								$('.winkelwagen_status span.badge').html( '0' );
							} else {
								$('.winkelwagen_status').html('Uw winkelwagentje is leeg');
							}
						} else {
							if(result.data.kumulus) {
								$('#aantal_'+result.data.existing_item).html(result.data.total_count);
							}

							if($(".winkelwagen_status span.badge").length ) {
								$('.winkelwagen_status span.badge').html( result.data.total_count );
								if(result.data.total_count === 0) {
									$(".winkelwagen_status span.badge").addClass('d-none');
								}
							} else {
								$('.winkelwagen_status').html( 'Uw winkelwagen bevat '+ result.data.total_count +' item'+ (result.data.total_count > 1 ? 's' : ''));
							}

							$('#total_price').html( '&euro;'+ result.data.total_discount_price );
						}

						$('#fb_alert .msg').html( 'Het item is uit het winkelmandje verwijderd!' );
						$('#myModal .modal-body').html( 'De activiteit is uit het winkelmandje verwijderd!' );
					} else {
						$('#fb_alert .msg').html( result.errors.message );
						$('#myModal .modal-body').html( result.errors.message );
					}

					// Bootstrap
					if (bootstrap_tpl) {
						$('#myModal').modal('show');
					} else {
						$.fancybox({
							'padding': 0,
							'margin': 0,
							'autoDimensions': true,
							'enableEscapeButton': false,
							'showCloseButton': false,
							'transitionIn': 'none',
							'transitionOut': 'none',
							'content': $('#fb_alert').html(),
							'onStart': function () {
								$('#fancybox-outer').css({
									'background': 'transparent'
								});
								$('#fancybox-bg-n,#fancybox-bg-ne,#fancybox-bg-e,#fancybox-bg-se,#fancybox-bg-s,#fancybox-bg-sw,#fancybox-bg-w,#fancybox-bg-nw').css({
									'background-image': 'none'
								});
							}
						});
					}

					$("a.close_alert").click(function() {
						$.fancybox.close();
					});
				});

				return false;
			}
			if ($target.is($toggleItems) || $target.is($toggleItems.find("span"))) {
				e.preventDefault();
				let $toggler = ($target.is($toggleItems.find("span"))) ? $target.parent($toggleItems) : $target;
				let $timeTable = $toggler.next('.times');
				if ($timeTable.length) {
					$toggler.toggleClass("active");
					$timeTable.stop(true,true).slideToggle();
				}
			}
			if ($target.is($basketEditAdd)) {
				// $.get($(this).attr('href') + '&smarty=yes&pida=yes', function(response) {
				$.get($target.attr('href'), function(response) {
					let result = JSON.parse(response);
					if (result.success) {
						$(".basket.edit .items").append(result.data.html);
					}
				});
				return false;
			}
			if ($target.is($basketEditItemsRemove) || $target.is($basketItemsRemove)) {
				remove_from_basket($(this));
				return false;
			}
		}

		if (e.type === "change") {
			if ($target.is($county_id)) {
				//Als het een vereniging betreft gebruiken we de gemeente id van die vereniging om de prijs te berekenen.
				if(typeof ($(this).data('county_id')) !== "undefined") {
					$calcprice.data('county_id', $(this).data('county_id'));
				} else {
					$calcprice.data('county_id', $(this).val());
				}
				if(typeof ($(this).data('cp')) === "undefined" || $(this).data('cp') === true) {
					VUGRON.Main.calculate_price();
				}
			}

			if ($target.is($customerType)) {
				if ($($target).is(':checked') || $($target).attr('type') === 'hidden') {
					if( $($target).val() === 'union') {
						$('.private_person .required').prop('required', false);
						$('.union .required').prop('required', true);
						$('.private_person').hide();
						$('.union').show();
					} else {
						$('.private_person .required').prop('required', true);
						$('.union .required').prop('required', false);
						$('.private_person').show();
						$('.union').hide();
					}
					if (typeof $(".grid").masonry === "function") { //Oude kumulus tpl
						$(".grid").masonry({
							columnWidth: 320,
							itemSelector: '.grid-item'
						});
					}
				}
			}

			if ($target.is($who)) {
				if($target[0].checked === true) {
					let $thisChecked = $('input[name="who"]:checked');

					let student = $thisChecked.data('student');
					let student_nr = $thisChecked.data('student_nr');
					let county_id = $thisChecked.data('county_id');
					let birth_date = $thisChecked.data('birth_date');
					let student_age = $thisChecked.data('age');

					$calcprice.data('county_id', county_id );
					$calcprice.data('birth_date', birth_date );
					$calcprice.data('student', student );
					$calcprice.data('student_nr', student_nr );

					if ($('#allow_use_of_images').length > 0) {
						let allow_use_of_images = 0;    //Standaard UIT!
						if('allow_use_of_images' in $target[0].dataset) {   //Waarde in dataset gevonden? Dan die gebruiken
							allow_use_of_images = $thisChecked.data('allow_use_of_images');
						}

						$('#allow_use_of_images').prop("checked", allow_use_of_images); //Vinkje aan/uit
					}

					if(typeof $("select[name='county_id']") === 'object') {
						$("select[name='county_id']").val(county_id);
					}
					if(typeof $("input[name='birth_date']") === 'object') {
						$("input[name='birth_date']").val(birth_date);
					}

					let $someone_else_required_input_elems = $target.closest("form").find(".not_me input.required");

					if($thisChecked.val() === 'someone_else' || $('input[type="hidden"][name="who"]').val() === 'someone_else') {
						// console.log('$target.closest("form").find("input.required"):', $target.closest("form").find("input.required"));
						$someone_else_required_input_elems.attr('required', true);
						$(".nostudent").hide();
						$('.me').hide();
						$('.not_me').show();
					} else {
						$someone_else_required_input_elems.removeAttr('required');

						if(student === '1') {
							$('#student').prop('checked', true);
							if (typeof $(".grid").masonry === "function") { //Oude kumulus tpl
								$('#collapseStudent').collapse('show');
							} else {
								$('#collapseStudent').show();
							}
						} else {
							$('#student').prop('checked', false);
							if (typeof $(".grid").masonry === "function") { //Oude kumulus tpl
								$('#collapseStudent').collapse('hide');
							} else {
								$('#collapseStudent').hide();
							}
						}
						$("#student_nr").val(student_nr);
						$('.me').show();
						$('.not_me').hide();
					}

					if($('.minutecard_btn').length > 0) {
						// valkenswaard specifiek voor nu, class naam bestaat alleen bij valkenswaard in muziekschool-v2 template
						if((student_age !== undefined && parseInt(student_age) >= 0 && parseInt(student_age) < 21)
							|| ($thisChecked.val() === 'someone_else' || $('input[type="hidden"][name="who"]').val() === 'someone_else')
						) {
							$('div.minutecard_btn[data-from_twentyone="1"]').hide();
							$('div.minutecard_btn[data-from_twentyone="1"]').parent().hide();

							$('input[name=amount_lessons][value="38"]').prop('checked', true);	// doorlopend selecteren voor het geval een knop was geselcteerd die verborgen wordt
						} else {
							$('div.minutecard_btn[data-from_twentyone="1"]').parent().show();
							$('.minutecard_btn').show();
						}
					}

					if (typeof $(".grid").masonry === "function") {
						$(".grid").masonry({
							columnWidth: 320,
							itemSelector: '.grid-item'
						});
					}
					VUGRON.Main.calculate_price(birth_date);
				}
			}

			if ($target.is($radioPtype)) {
				let sel = $('input[type=radio][name=ptype]:checked').val();

				$('.bank').hide();
				$('input[name=accept_incasso]').removeAttr('required');
				$('.issuer_list').hide();
				$('.info.other').hide();
				$('.cart_payment_method .button.primary').show();

				if (sel == 'ideal') {
					$('.issuer_list').show();
				} else if (sel === 'other') {
					$('.info.other').show();
					$('.cart_payment_method .button.primary').hide();
				} else if (sel === 'incasso' || sel.indexOf("installments") !== -1) {
					$('.bank').show();
					// $('.bank').addClass(' required');
					$('input[name=accept_incasso]').attr("required", true);
				}
			}

			if ($target.is($radioPaymentmethod)) {
				let sel = $('input[type=radio][name=paymentmethod]:checked').val();
				if(typeof (sel) !== "undefined") {
					$('.bank').hide();
					$('input[name=bank_account]').removeAttr('required');
					$('input[name=accept_incasso]').removeAttr('required');
					$('select[name=issuer_id]').removeAttr('required');
					$('.issuer_list').hide();
					$('.info.other').hide();
					$('.register .payment_method .button.primary').show();

					if (sel == 'ideal') {
						$('.issuer_list').show();
					} else if (sel === 'other') {
						$('.info.other').show();
						$('.register .payment_method .button.primary').hide();
					} else if (sel === 'incasso' || sel.indexOf("installments") !== -1) {
						$('.bank').show();
						$('input[name=bank_account]').attr("required", true);
						$('input[name=accept_incasso]').attr("required", true);
					}
				}
			}

			//Is nu opgelost met andere regex
			// if ($target.is($iban)) {
			// 	const baseUrl = window.location.origin + window.location.pathname;
			// 	$.post({
			// 		url: baseUrl + '?pi=' + $($target).data('pi') + '&action=validate_iban',
			// 		data: {
			// 			iban: $($target).val()
			// 		},
			// 		dataType: 'json',
			// 		success: function (result) {
			// 			if(!result.success) {
			// 				$target.parent().addClass( "is_invalid" );
			// 			} else {
			// 				$target.parent().removeClass( "is_invalid" );
			// 			}
			// 		}
			// 	});
			// }

			if ($target.closest($selectAantal).length) {
				$("body :input").prop("disabled", true);
				let aantal = $target.closest($selectAantal).val();
				let cart_item = $target.closest($selectAantal).data('cart_item');
				let shoppingcartlink = $(".cart_summary form").data('shoppingcartlink');
				$.ajax({
					url: shoppingcartlink + '&action=update_cart',
					data: {
						cart_item: cart_item,
						aantal: aantal
					},
					dataType: 'json',
					success: function(result) {
						// location.reload();
						$('.winkelwagen_status').html('Uw winkelwagen bevat ' + result.data.total_count + ' item' + (result.data.total_count > 1 ? 's' : ''));
						$(".row.item[data-cart_item='"+ cart_item +"'] .price").html( '&euro; '+ result.data.price );
						$( "#total_price").html( '&euro; '+ result.data.total_discount_price );

						$("body :input").prop("disabled", false);
					}
				});
			}

			if ($target.closest($selectPerson).length) {
				$("body :input").prop("disabled", true);
				let person_id = $target.closest($selectPerson).val();
				let cart_item = $target.closest($selectPerson).data('cart_item');
				let shoppingcartlink = $(".cart_summary form").data('shoppingcartlink');
				$.ajax({
					url: shoppingcartlink + '&action=update_cart',
					data: {
						cart_item: cart_item,
						person_id: person_id
					},
					dataType: 'json',
					success: function(result) {
						$('.winkelwagen_status').html('Uw winkelwagen bevat ' + result.data.total_count + ' item' + (result.data.total_count > 1 ? 's' : ''));
						$( ".item_"+ cart_item +" .price").html( '&euro; '+ result.data.price );
						$( "#total_price").html( '&euro; '+ result.data.total_discount_price );

						$("body :input").prop("disabled", false);
					}
				});
			}

			if ($target.is($country)) {
				let country_val = $($target).val();
				let $address = $('#address');
				let $city = $('#city');
				let $postcode = $('#postcode');
				let $iban = $('[data-custom-pattern="iban"]');

				if(country_val === 'DE') {
					// $address
					// 	.attr('readonly', false)
					// 	.removeAttr("tabindex")
					// 	.data('data-fv-notempty', true);
					// $city
					// 	.attr('readonly', false)
					// 	.removeAttr("tabindex");
					$postcode
						.attr('pattern', VUGRON.Main.constants.pattern_zip_DE)
						.next('.invalid-feedback').text(VUGRON.Main.constants.zip_message_DE);
					$iban
						.attr('pattern', VUGRON.Main.constants.pattern_iban);

				} else if(country_val === 'NL') {
					// $address
					// 	.attr('readonly', true)
					// 	.attr('tabindex', '-1');
					// $city
					// 	.attr('readonly', true)
					// 	.attr('tabindex', '-1');
					$postcode
						.attr('pattern', VUGRON.Main.constants.pattern_zip_NL)
						.next('.invalid-feedback').text(VUGRON.Main.constants.zip_message);
					$iban
						.attr('pattern', VUGRON.Main.constants.pattern_iban);

				} else if(country_val === 'BE') {
					// $address
					// 	.attr('readonly', false)
					// 	.removeAttr("tabindex");
					// $city
					// 	.attr('readonly', true)
					// 	.attr('tabindex', '-1');
					$postcode
						.attr('pattern', VUGRON.Main.constants.pattern_zip_BE)
						.next('.invalid-feedback').text(VUGRON.Main.constants.zip_message);
					$iban
						.attr('pattern', VUGRON.Main.constants.pattern_iban);
				}

				let cid = -1;	// overige gemeenten
				if( $('#county_id').length > 0) {
					cid =  $('#county_id option:selected').val();
				}

				// $('#postcode').val('');
				$('#county_id').val(cid);
				$('#calc_price').data('county_id', cid);

				// $('#postcode').trigger('focusout');
/*				$postcode.trigger('keyup');
				$postcode.on('focusout keyup', function() {
					console.log('keyup..')
				});*/
				// VUGRON.Main.formValidation();
				// $target.closest('form')[0].reportValidity();
				/*let zipInput = document.getElementById('postcode');
				if (typeof (zipInput) !== "undefined" && zipInput != null) {
					VUGRON.Main.revalidate(zipInput);
					// $(zipInput).trigger('change');
				}*/
			}

			if ($target.closest($amount).length || $target.closest($sort).length || $target.closest($customer_type).length || $target.closest($ctype).length || $target.closest($plaats).length || $target.closest($tloc).length || $target.closest($age).length || $target.closest($agid).length || $target.closest($wgid).length || $target.closest($location_id).length) {
				$target.closest('form').submit();
			}

			if ($target.is($amount_lessons) || $target.is($lessonduration_id) || $target.is($lesson_duration) || $target.is($req_startdate)) {
				let cur_cursus_id = $("#calc_price").data('cursus_id');
				let birth_date = $("#calc_price").data('birth_date');

				updateCalcprice(e.target, function() {
					VUGRON.Main.update_schedule(function() {
						VUGRON.Main.calculate_price(birth_date, cur_cursus_id);
					});
				});
			}

			if ($target.is($birth_date)) {
				updateCalcprice(e.target);  //Incl. calculate_price();
			}

			if($target.is($selected_course)) {
				let birth_date = $("#calc_price").data('birth_date');

				VUGRON.Main.update_schedule(function() {
					//Anders wordt de prijs niet bijgewerkt als je van variant switched
					//Als er niet ingelogd is dan zal birth_date leeg zijn.
					VUGRON.Main.calculate_price(birth_date, $selected_course_checked.val());
				});
			}

			if ($target.is($req_time) || $target.is($teacher_id)) {
				VUGRON.Main.update_schedule();	//Moet hier als callback misschien ook nog calc_price gedaan worden?
			}

			if ($target.is($basketEditSelectGroupId)) {
				let student_qty = $($target).closest('.course').find('input.student_qty');
				student_qty.val( $($target).children("option:selected").data('student_qty') );
			}

			if ($target.closest($basketSelectNumberItems).length) {
				// console.log($(this));
				if(typeof ($target.closest($basketSelectNumberItems).data('order-item')) !== "undefined") {
					$.post({
						url: window.location.href + 'bewerken/' +  $target.closest($basketSelectNumberItems).data('order-item'),
						data: {
							number_of_items: $target.closest($basketSelectNumberItems).val()
						},
						dataType: 'json',
						success: function (result) {
							if(result.data.charged_price != 0) {
								$(".item_" + $target.closest($basketSelectNumberItems).data('order-item') + " label.charged_price").html( 'Totaal prijs: &euro; '+ result.data.charged_price );
							}
						}
					});
				}
			}

			if ($target.is("#housenumber")) {
				e.stopPropagation();
				$(".address").applyAutocomplete({
					pro6ppAuthKey: 'ntEsAjRku2urwkDD'
				});

				if($("#postcode").val() !== "" && $("#housenumber").val() !== "") {
					//Triggers pro6pp call
					$("#housenumber").blur();
				}
			}
			/*if ($target.is($basketSelectNumberItems)) {
				// console.log($(this));
				if(typeof ($(this).data('order-item')) !== "undefined") {
					let data = {
						number_of_items: $(this).val()
					};
					$.post(window.location.href + 'bewerken/' +  $(this).data('order-item'), data);
				}
			}*/
		}

		// FF
		$('select[name="field_why_us_selected"]').find('option').click(function () {
			var optionSelected = $(this);
			var valueSelected  = optionSelected.val();

			if(valueSelected.toLowerCase().indexOf('anders') >= 0 || valueSelected.toLowerCase().indexOf('*') >= 0 || valueSelected.toLowerCase().indexOf('namelijk') >= 0) {
				$('#field_why_us_anders_option').show();
			} else {
				$('#field_why_us_anders_option').hide();
			}
		});
	});

	//FullCalendar
	let $calendarEl = $('div#fullcalendar');

	if($calendarEl.length) {
		var calendar = new FullCalendar.Calendar($calendarEl[0], {
			locale: 'nl',
			timeZone: 'local',
			initialView: 'timeGridWeek',
			themeSystem: 'bootstrap',
			height: 'auto',
			allDaySlot: false,
			slotEventOverlap: false,
			scrollTime: '08:00:00',
			slotMinTime: '07:00:00',
			slotMaxTime: '23:00:00',
			headerToolbar: {
				left: 'prev,next today',
				center: 'title',
				right: 'timeGridWeek,listWeek'
			},
			events: $calendarEl.data('feed'),
			// eventBackgroundColor: '#ee0000',
			// eventBorderColor: '#3788d8',
			businessHours: {
				// days of week. an array of zero-based day of week integers (0=Sunday)
				daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
				startTime: '08:00:00', // a start time (8am in this example)
				endTime: '21:00', // an end time (6pm in this example)
			},
			eventClick: function (info) {
				var myModal = new bootstrap.Modal(document.getElementById('fullcalendarModal'))

				$('#fullcalendarModal').on('show.bs.modal', function () {
					$('.modal-title').text(info.event.title);

					$('.modal-body span.date').text( moment(info.event.start).format('LL') );
					$('.modal-body span.time').text( moment(info.event.start).format('LT') + ' - ' + moment(info.event.end).format('LT'));
					$('.modal-body span.teacher').text( info.event.extendedProps.teacher );
					$('.modal-body span.person').text( info.event.extendedProps.person );

					$('.modal-body div.group').hide();
					if(info.event.extendedProps.schoolgroup > 0) {
						$('.modal-body span.group').text( info.event.extendedProps.group_name );
						$('.modal-body div.group').show();
					}

					$('.modal-body div.location').hide();
					if(info.event.extendedProps.location_id > 0) {
						$('.modal-body span.location').text( info.event.extendedProps.location )
						$('.modal-body div.location').show();
					}
				});

				myModal.show();
			},
			windowResize: function(arg) {
				//For smaller screens set view to 'listWeek'
				if(window.innerWidth > 980) {
					calendar.changeView('timeGridWeek');
					calendar.setOption('headerToolbar', { right: 'timeGridWeek,listWeek' });
				} else {
					calendar.changeView('listWeek');
					calendar.setOption('headerToolbar', { right: '' });
				}
			}
		});
		calendar.render();

		if(window.innerWidth <= 980) {
			calendar.changeView('listWeek');
			calendar.setOption('headerToolbar', { right: '' });
		}
	}

	//Needs to be triggered, for initial show/hide bank of issuer_list
	$("input[type=radio][name=paymentmethod]").change();
	$("input[name=customer_type]").change();
	//Needs to be triggered for postal validation
	$("#country").change();
	$("#housenumber").change();

	//If teacher-select (radio) is possible; initial select first teacher en update schedule (availability).
	if ($('input[name="teacher_id"]').attr('type') === 'radio' && !$('input[name="teacher_id"]').filter(':checked').length) {
		$('input[name="teacher_id"]')[0].checked = true;
		VUGRON.Main.update_schedule();
	}

	VUGRON.Main.calculate_price();

	$("a.rental_filter").click(function() {
		let $me = $(this);
		BART.Front.Util.createCookie('ldjn_rcat', $(this).data('cid'));
		$.get($(this).attr('href') + '&smarty=yes&pida=yes', function(response) {
			$me.data('rc').html( response );
		});
		return false;
	});

	$("a.register").click(function() {
		$(".mod_restriction .register").show();
		$(".title_between").show();
		$(this).hide();
	});

	$('#county_id').change(function() {
		$('#calc_price').data('county_id', $(this).val());
	});

	$('#deleteGroupModal').on('show.bs.modal', function (event) {
		$(this).find('input[name="group_id"]').val( $(event.relatedTarget).data('group_id') );
	});

	function updateCalcprice(el, callback) {
		$('#calc_price').data('"' + el.name + '"', $(el).val());

		//Blijkbaar duurt het updaten van .data even; vandaar (helaas) deze timeout, anders wordt in ieder geval een verkeerde req_startdate mee gegeven aan de calc_price
		//setTimeout(function() {
		// 	if(doRecalculate !== undefined && !doRecalculate) {
		// 		// doe niks, anders wordt eerst een extra rcalulateprice gedaan met verkeerde data
		// 	} else {
		// 		VUGRON.Main.calculate_price();
		// 	}

			if(callback !== undefined) {
				callback.call();
			}
		//}, 1000);
	}

	function remove_from_basket(t) {
		$.get(t.attr('href'), function(response) {
			let result = JSON.parse(response);

			if(result.success) {
				$('.basket .item_'+result.data.item).remove();

				if(typeof (result.data.redirect) !== "undefined" && result.data.redirect !== '') {
					$('.basket.edit .buttons').remove();
					$('.mod_vugron .basket .items').html( '<p>Terug naar het winkelmandje...</p>' );
					window.location.href = result.data.redirect;
					return false;
				}

				if(typeof (result.data.total_count) !== "undefined") {
					if(result.data.total_count === 0) {
						// $('.cart_info a.primary.button').addClass('hidden');
						$('.mod_vugron .basket .items').html( '<p>Uw winkelmandje is leeg</p>' );

						if($(".basket_status span.badge").length) {
							$('.basket_status span.badge').html( '0' );
							$(".basket_status span.badge").addClass('d-none');
						} else {
							$('.basket_status').html('Uw winkelwagentje is leeg');
						}
					} else {
						if($(".basket_status span.badge").length ) {
							$('.basket_status span.badge').html( result.data.total_count );
						} else {
							$('.basket_status').html( 'Uw winkelwagen bevat '+ result.data.total_count +' item'+ (result.data.total_count > 1 ? 's' : ''));
						}

						// $('#total_price').html( '&euro;'+ result.data.total_discount_price );
					}
				}

				// $('#fb_alert .msg').html( 'Het item is uit het winkelmandje verwijderd!' );
				// $('#myModal .modal-body').html( 'Het item is uit het winkelmandje verwijderd!' );
			} else {
				$('#fb_alert .msg').html( result.errors.message );
				$('#myModal .modal-body').html( result.errors.message );
			}

			// // Bootstrap
			// if (bootstrap_tpl) {
			// 	$('#myModal').modal('show');
			// } else {
			// 	$.fancybox({
			// 		'padding': 0,
			// 		'margin': 0,
			// 		'autoDimensions': true,
			// 		'enableEscapeButton': false,
			// 		'showCloseButton': false,
			// 		'transitionIn': 'none',
			// 		'transitionOut': 'none',
			// 		'content': $('#fb_alert').html(),
			// 		'onStart': function () {
			// 			$('#fancybox-outer').css({
			// 				'background': 'transparent'
			// 			});
			// 			$('#fancybox-bg-n,#fancybox-bg-ne,#fancybox-bg-e,#fancybox-bg-se,#fancybox-bg-s,#fancybox-bg-sw,#fancybox-bg-w,#fancybox-bg-nw').css({
			// 				'background-image': 'none'
			// 			});
			// 		}
			// 	});
			// }
			//
			// $("a.close_alert").click(function() {
			// 	$.fancybox.close();
			// });
		});

		return false;
	}

	// todo
	if ( $('input[name="who"]').length ) {
		$('input[name="who"]').change();
	}

	$(document).ajaxComplete(function() { // event, xhr, settings
		VUGRON.Main.formValidation();
		/*console.log("event:",event);console.log("xhr:",xhr);console.log("settings:",settings);*/
	});

	$('.modal.autoshow').modal('show');
});


/***************
 ** Polyfills **
 **************/

/**
 * scrollIntoViewIfNeeded
 *
 * Polyfill for https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded
 * Usage example: document.querySelector(".element").scrollIntoViewIfNeeded(false);
 */
if (!Element.prototype.scrollIntoViewIfNeeded) {
	Element.prototype.scrollIntoViewIfNeeded = function(centerIfNeeded) {

		function makeRange(start, length) {
			return {
				"start": start,
				"length": length,
				"end": start + length
			};
		}

		function coverRange(inner, outer) {

			if (
				false === centerIfNeeded || (outer.start < inner.end && inner.start < outer.end)) {
				return Math.max(
					inner.end - outer.length,
					Math.min(outer.start, inner.start));
			}
			return (inner.start + inner.end - outer.length) / 2;
		}

		function makePoint(x, y) {
			return {
				"x": x,
				"y": y,
				"translate": function translate(dX, dY) {
					return makePoint(x + dX, y + dY);
				}
			};
		}

		function absolute(elem, pt) {
			while (elem) {
				pt = pt.translate(elem.offsetLeft, elem.offsetTop);
				elem = elem.offsetParent;
			}

			return pt;
		}

		let target = absolute(this, makePoint(0, 0)),
			extent = makePoint(this.offsetWidth, this.offsetHeight),
			elem = this.parentNode,
			origin;

		while (elem instanceof HTMLElement) {

			// Apply desired scroll amount.
			origin = absolute(elem, makePoint(elem.clientLeft, elem.clientTop));
			elem.scrollLeft = coverRange(
				makeRange(target.x - origin.x, extent.x),
				makeRange(elem.scrollLeft, elem.clientWidth));
			elem.scrollTop = coverRange(
				makeRange(target.y - origin.y, extent.y),
				makeRange(elem.scrollTop, elem.clientHeight));

			// Determine actual scroll amount by reading back scroll properties.
			target = target.translate(-elem.scrollLeft, - elem.scrollTop);
			elem = elem.parentNode;
		}
	};
}



/**
 * Trigger any event
 * Usage example:
 *		var el = document.querySelector('input[type="text"]');
 *		triggerEvent(el, 'mousedown');
 */

function triggerEvent(el, type){
	// console.log('el:',el);
	// console.log('type:',type);
	if ('createEvent' in document) {
		// modern browsers, IE9+
		var e = document.createEvent('HTMLEvents');
		e.initEvent(type, false, true);
		el.dispatchEvent(e);
	} else {
		// IE 8
		var e = document.createEventObject();
		e.eventType = type;
		el.fireEvent('on'+e.eventType, e);
	}
}
